import Button from '@repo/ui/button'
import { MODAL_CONTENT_CLASSNAME } from '@repo/ui/modal'
import { useState } from 'react'

import TextInput from '../../../../../../packages/ui/components/atoms/input/text-input'

type Props = {
  isLoading?: boolean
  onCancel: () => void
  onConfirm: (cancellationReason?: string) => void
}

const MissionStaffCancellationForm = ({ isLoading, onCancel, onConfirm }: Props) => {
  const [cancellationReason, setcancellationReason] = useState<string>()

  return (
    <div className={MODAL_CONTENT_CLASSNAME}>
      <TextInput
        type="textarea"
        value={cancellationReason}
        label="Merci de préciser la raison de cette annulation :"
        placeholder="Raison de l annulation"
        onChange={(e) => {
          setcancellationReason(e.target.value)
        }}
      />

      <div className="h-10" />
      <div className="flex w-full gap-3">
        <Button
          type="button"
          variant="ghost"
          label="Fermer"
          className="w-full"
          onClick={onCancel}
        />
        <Button
          type="button"
          variant="destructive"
          label="Annuler"
          className="w-full"
          loading={isLoading}
          onClick={() => {
            onConfirm(cancellationReason)
          }}
        />
      </div>
    </div>
  )
}

export default MissionStaffCancellationForm
